(function () {
  // ========================================
  // Drag-to-scroll functionality
  // ========================================
  function makeDraggable(el) {
    if (!el) return;
    var dragging = false,
      startX,
      scrollL;
    el.addEventListener('mousedown', function (e) {
      dragging = true;
      startX = e.pageX - el.offsetLeft;
      scrollL = el.scrollLeft;
    });
    el.addEventListener('mouseleave', function () {
      dragging = false;
    });
    el.addEventListener('mouseup', function () {
      dragging = false;
    });
    el.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      el.scrollLeft = scrollL - (e.pageX - el.offsetLeft - startX);
    });
  }

  // ========================================
  // Ribbon timeline — dynamic colors, assets + SVG
  // ========================================
  (function () {
    // Find all ribbon tracks (support multiple instances)
    var tracks = document.querySelectorAll('[data-section-type="awards-ribbon"] .ribbon-track');

    if (!tracks.length) return;

    var palette = [
      {
        color: '#3B67A5',
        assetIndex: 0,
      },
      {
        color: '#F79321',
        assetIndex: 1,
      },
      {
        color: '#32B44A',
        assetIndex: 2,
      },
      {
        color: '#ED2226',
        assetIndex: 3,
      },
    ];

    tracks.forEach(function (track) {
      var nodes = track.querySelectorAll('.ribbon-node');
      if (!nodes.length) return;

      // Find the parent section to get doodle asset URLs
      var section = track.closest('[data-section-type="awards-ribbon"]');
      var doodleUrls = [
        section.getAttribute('data-doodle-0'),
        section.getAttribute('data-doodle-1'),
        section.getAttribute('data-doodle-2'),
        section.getAttribute('data-doodle-3'),
      ];

      // Assign colors and doodle assets to nodes
      nodes.forEach(function (node, i) {
        var entry = palette[i % palette.length];
        node.style.setProperty('--node-color', entry.color);
        var dot = node.querySelector('.ribbon-dot');
        if (dot) {
          var img = dot.querySelector('img');
          if (!img) {
            img = document.createElement('img');
            dot.appendChild(img);
          }
          if (doodleUrls[entry.assetIndex]) {
            img.src = doodleUrls[entry.assetIndex];
          }
          img.alt = '';
        }
      });

      // Generate wavy ribbon SVG based on node count
      var nodeW = 200; // matches CSS .ribbon-node width
      var totalW = nodes.length * nodeW;

      // Check if SVG already exists
      var existingSvg = track.querySelector('.ribbon-line');
      if (existingSvg) {
        existingSvg.remove();
      }

      var svg = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'svg',
      );
      svg.setAttribute('class', 'ribbon-line');
      svg.setAttribute('viewBox', '0 0 ' + totalW + ' 48');
      svg.setAttribute('preserveAspectRatio', 'none');

      var d = 'M0 24';
      var segW = nodeW;
      for (var i = 0; i < nodes.length; i++) {
        var x = (i + 1) * segW;
        var cp = i % 2 === 0 ? 6 : 42;
        d += ' S' + (x - segW / 2) + ' ' + cp + ', ' + x + ' 24';
      }

      var path = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path',
      );
      path.setAttribute('d', d);
      svg.appendChild(path);
      track.insertBefore(svg, track.firstChild);
    });
  })();

  // ========================================
  // Enable drag-to-scroll on all ribbons
  // ========================================
  var ribbons = document.querySelectorAll('.awards-ribbon');
  ribbons.forEach(function (ribbon) {
    makeDraggable(ribbon);
  });
})();
